export class SaasEntitySnapshot {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "dateCreated",
            "baseName": "dateCreated",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "pointInTime",
            "baseName": "pointInTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "snapshotStatus",
            "baseName": "snapshotStatus",
            "type": "string",
            "format": ""
        },
        {
            "name": "vaultId",
            "baseName": "vaultId",
            "type": "string",
            "format": ""
        },
        {
            "name": "hasPartialData",
            "baseName": "hasPartialData",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "entityBackupStatus",
            "baseName": "entityBackupStatus",
            "type": "SaasBackupStatus",
            "format": ""
        },
        {
            "name": "workloadStatuses",
            "baseName": "workloadStatuses",
            "type": "Array<SaasWorkloadStatus>",
            "format": ""
        },
        {
            "name": "captureOutcome",
            "baseName": "captureOutcome",
            "type": "SaasCaptureOutcome",
            "format": ""
        },
        {
            "name": "captureReason",
            "baseName": "captureReason",
            "type": "SaasCaptureReason",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaasEntitySnapshot.attributeTypeMap;
    }
    constructor() {
    }
}
